<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="signUpInfo">
		<div class="signUpInfo_container">
			<div class="nav" v-if="navShow">
				<a :href="navhomeUrl" target="_top">首页</a>
				> <a>会议直播</a>
			</div>
			<div class="banner-img" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
				<img :src="meetingInfo.MobileBannerImage">
			</div>
			<div class="signUpInfo_content">
				<div id="meeting_info" class="commonW">
					<div v-if="schedule!=null && schedule.length>0">
						<div class="schedule-date">
							<div class="schedule-date-item" v-for="(item,index) in schedule" :key='index'
								:class="{'active':active==index}" @click="changeDate($event,index)">
								<div class="item-liveWeek">
									{{item.LiveWeek}}
								</div>
								<div class="item-liveDate">
									{{item.LiveDate}}
								</div>
							</div>
						</div>
						<div class="schedule-meeting" v-if="scheduleList!=null && scheduleList.length>0">
							<div class="meeting-list" v-for="(item,index) in scheduleList" :key='index'>
								<div class="meeting-liveBanner">
									<img :src="item.LiveBanner">
								</div>
								<div class="meeting-con">
									<a v-bind:href="item.LiveLink" target="_top">
										<div class="meeting-title">
											{{item.Title}}
										</div>
										<div class="meeting-live">
											<div class="meeting-liveTimer">
												时间:{{item.LiveTimer}}
											</div>
											<div class="meeting-liveStatus">
												<span class="liveStatus liveStatus1" v-if="item.LiveStatus==0">
													未开始
												</span>
												<span class="liveStatus liveStatus2" v-if="item.LiveStatus==1">
													正在直播
												</span>
												<span class="liveStatus liveStatus3" v-if="item.LiveStatus==2">
													已结束
												</span>
												<span class="liveStatus liveStatus3" v-if="item.LiveStatus==3">
													观看回放
												</span>
											</div>
										</div>
									</a>
								</div>
							</div>
						</div>
						<div class="noDate" v-else>
							该日期暂无会议信息
						</div>
					</div>
					<div class="noDate" v-else>
						暂无会议信息
					</div>
				</div>
			</div>
		</div>
		<div id="foot" v-if="footShow">
			<a :href="LogoLink"  target="_blank"><img :src="LogoImg"/></a>
			{{LogoTxt}}
		</div>
	</div>
</template>
<script>
	import {
		initMeetingInfo,
		liveMeeting
	} from "@/api/modules/live/index.dto";
	import {
		IMeetingInfo,
		current
	} from "@/contants/current";
	export default {
		name: 'liveInfo',
		data() {
			return {
				params: {
					m: '',
					red: '',
				},
				footShow: true,
				meetingInfo: '',
				show: false,
				loading: false,
				schedule: [],
				scheduleList: [],
				active: 0,
				red: '',
				navShow: true,
				navhomeUrl: '',
				LogoTxt: '',
				LogoLink: '',
				LogoImg: '',

			}
		},
		created() {
			this.params = this.$route.query
			this.red = this.params.red
			let opt = {
				m: this.params.m
			}
			this.current = new current();
			let _isMobile = this.current.is_Mobile();
			console.log(_isMobile)
			if (_isMobile) {
				let _params = window.location.href.split("?")[1];
				window.location.href = `https://mp.weiqihd.com/mpweb/#/liveInfo?${_params}`;
			}
			this.initMeetingInfo();
			this.initmeeting(opt)
			this.init(opt)
		},
		mounted() {
			//this.swiperInit()
		},
		methods: {
			async initMeetingInfo() {
				let params = {
					m: this.params.m
				};
				let res = await IMeetingInfo.InitMeetingInfo(params);
				this.LogoTxt = res.LogoTxt
				this.LogoLink = res.LogoLink
				this.LogoImg = res.LogoImg
				if( res.isshowlogo == 0 ){
				    this.footShow = true
				}else{
				    this.footShow = false
				}
			},
			async initmeeting(opt) {
				this.show = true
				this.meetingInfo = await this.$http.live.GetAPIProgram(opt);
				if (this.meetingInfo.Code === 1000) {
					this.show = false
					if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.navhomeUrl = this.meetingInfo.HomeUrl
					}
					
				} else {
					this.$notify({
						massage: this.meetingInfo.Msg,
						type: 'danger',
						duration: '3000',
					})
				}
			},
			/**
			 * 初始化报名用户数据
			 */
			async init(opt) {
				try {
					this.loading = true
					let res = await this.$http.live.GetMeetingLive(opt);
					console.log(res)
					if (res.Code === 0) {
						this.loading = false
						this.schedule = res.LiveData
						if (this.schedule != null && this.schedule.length > 0) {
							this.scheduleList = this.schedule[this.active].LiveDatas
						}
					} else {
						this.$notify({
							message: res.Msg,
							type: 'primary',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},

			changeDate(e, index) {
				let that = this
				that.active = index
				that.scheduleList = []
				that.scheduleList = that.schedule[index].LiveDatas
			},
		},
	}
</script>
<style lang="scss" scoped>
	.signUpInfo-banner {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.signUpInfo-banner .swiper-slide {
		position: relative;
		text-align: center;
	}

	.signUpInfo-banner img {
		max-width: 100%;
		display: block;
	}

	.commonW {
		width: 100%;
		margin: 0 auto;
	}

	// ----------
	#signUpInfo {
		width: 750px;
		margin: 0 auto;

		.signUpInfo_container {
			padding-bottom: 70px;
			background: #fff;

			.live-data {
				border-top: 1px dashed #dce3ed;
				display: flex;

				.liveDiv {
					flex: 1;
					text-align: center;
					padding: 20px 0;
					font-size: 26px;

					p {
						color: #2c3e50;
						padding: 5px 0;
					}

					p:last-child span {
						font-size: 34px;
						color: #3b82f6;
						font-weight: bold;
					}
				}
			}

			.note {
				text-align: center;
				font-size: 22px;
				color: #94a3b8;
				margin-top: 20px;
			}

			.pay-btns {
				height: 60px;
				margin-top: 20px;
				border-top: 1px dashed #dce3ed;
				padding-top: 20px;

				.pay-btn {
					background: #409eff;
					width: 200px;
					height: 60px;
					text-align: center;
					line-height: 60px;
					color: #fff;
					float: right;
					margin-right: 20px;
					border-radius: 12px;
				}
			}

			.signUpInfo_content {
				.signUpInfo-banner {
					>img {
						width: 100%;
					}
				}
			}
		}
	}

	.schedule-date {
		display: flex;
		flex-wrap: wrap;
		padding: 20px 20px 0;
	}

	.schedule-date-item {
		cursor: pointer;
		float: left;
		background: #f1f5f9;
		border-radius: 12px;
		height: 60px;
		width: calc((100% - 48px)/5);
		margin-right: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
		flex-direction: column;
		transition: all 0.2s;
	}

	.schedule-date-item:nth-child(4n) {
		margin-right: 0;
	}

	.schedule-date-item.active {
		border: 2px solid #409eff;
		background: #f0f7ff;
	}

	.item-liveWeek {
		font-size: 18px;
		line-height: 24px;
		color: #94a3b8;
	}

	.item-liveDate {
		line-height: 24px;
		font-size: 16px;
		font-weight: 600;
		color: #2c3e50;
	}


	.schedule-meeting {
		padding: 0 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.meeting-list {
		width: calc((100% - 100px)/2);
		float: left;
		display: flex;
		margin-bottom: 20px;
		background-color: #fff;
		box-shadow: 0 2px 16px rgba(64, 158, 255, 0.08);
		border-radius: 16px;
		overflow: hidden;
		padding: 20px;
		margin-right: 20px;
		flex-direction: column;
		border: 1px solid #e2e8f0;
		transition: box-shadow 0.2s;
		&:hover {
			box-shadow: 0 4px 20px rgba(64, 158, 255, 0.14);
		}
	}

	.meeting-list:nth-child(2n) {
		margin-right: 0;
	}

	.meeting-liveBanner {
		width: 100%;
		height: 162px;
		border-radius: 12px;
		overflow: hidden;
	}

	.meeting-liveBanner img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.meeting-con {
		margin-top: 10px;

		a {
			display: block;
		}
	}

	.meeting-title {
		font-size: 16px;
		color: #1e293b;
		line-height: 25px;
		height: 50px;
		overflow: hidden;
		font-weight: 500;
	}


	.meeting-live {
		margin-top: 5px;
		display: flex;
	}

	.meeting-liveTimer {
		flex: 1;
		color: #94a3b8;
		line-height: 25px;
	}

	.noDate {
		text-align: center;
		padding: 20px;
		font-size: 14px;
		color: #94a3b8;
	}

	.meeting-liveStatus {
		width: 100px;
	}

	.liveStatus {
		display: block;
		width: 100px;
		height: 25px;
		text-align: center;
		line-height: 25px;
		border-radius: 13px;
		font-size: 14px;
	}

	.liveStatus a {
		display: block;
		width: 100%;
		height: 100%;
	}

	.liveStatus1 {
		border: 1px solid #dce3ed;
		color: #94a3b8;
	}

	.liveStatus2 {
		border: 1px solid #6366f1;
		color: #3b82f6;
		background: #f0f7ff;
	}

	.liveStatus3 {
		border: 1px solid #e2e8f0;
		color: #94a3b8;
	}

	.liveStatus1 a,
	.liveStatus3 a {
		color: #94a3b8;
	}

	.liveStatus2 a {
		color: #3b82f6;
	}

	.nav {
		height: 42px;
		font-size: 16px;
		line-height: 42px;
		background: linear-gradient(135deg, #1e5fa8, #409eff) url(../../assets/home.png) no-repeat 12px center;
		background-size: 24px 24px;
		color: #fff;
		padding: 0 20px 0 44px;
		border-radius: 0;

		a {
			color: #fff;
		}
	}

	.banner-img img {
		width: 100%;
	}

	#foot {
		position: fixed;
		width: 750px;
		height: 30px;
		text-align: center;
		bottom: 0;
		border-top: 1px solid #e0ecf8;
		background: #fafcfe;
		padding: 10px;
		color: #94a3b8;
		line-height: 30px;
		margin: 0 auto;
	}

	#foot img {
		display: inline-block;
		vertical-align: top;
		height: 30px;
		margin-right: 10px;
	}
</style>
